import { Tag } from '../../pages/tagsearch/[tagIds]';
import {
  SPECIALS,
  SPECIALS_KEYS,
  SpecialsKey,
  MOBILE_SPECIAL_BARS,
  Special,
  MobileSpecialBar,
} from '../constants';
import { isDoctorRecruiterAccount } from './user';

/**
 * `SPECIALS`オブジェクトからタグ名がマッチする最初の`Special`(特集)オブジェクトを取得する。
 */
export function findSpecialByTags(articleTags: Tag[]): Special | undefined {
  const matchingKey = SPECIALS_KEYS.find((key) => {
    const setting = SPECIALS[key];
    const bySingleTags: boolean = setting.tags.some((tagName) =>
      articleTags.some((t) => t.name === tagName),
    );
    // andTags設定値がある場合は、一セットのtag配列に含まれる全てのタグがarticleTagsに含まれているかを確認する
    const byAndTags: boolean = setting?.andTags
      ? setting.andTags.some((tags) =>
          tags.every((tagName) => articleTags.some((t) => t.name === tagName)),
        )
      : false;
    return bySingleTags || byAndTags;
  }) as SpecialsKey | undefined;
  return matchingKey ? SPECIALS[matchingKey] : undefined;
}

/**
 * MOBILE_SPECIAL_BOTTOM_BANNERS 配列からモバイルで下部にバナーを固定表示する設定値を取得する。
 */
export function findMobileSpecialBarByTags(
  tags: Tag[],
): MobileSpecialBar | undefined {
  return MOBILE_SPECIAL_BARS.find((special) =>
    special.tags.some((tag) => tags.some((t) => t.name === tag)),
  );
}

/**
 *  articleIds配列を持つSpecialから引数のarticleIdとマッチする最初の要素を返す
 */
export function findSpecialByArticleId(articleId: string): Special | undefined {
  const matchingKey = SPECIALS_KEYS.find((key) => {
    const setting = SPECIALS[key];
    if (!setting?.articleIds || !setting.articleIds.length) {
      return undefined;
    }
    return setting.articleIds.some((id) => id === articleId);
  }) as SpecialsKey | undefined;

  if (!matchingKey) {
    return undefined;
  }
  return SPECIALS[matchingKey];
}

/**
 * articleIdsのMOBILE_SPECIAL_BOTTOM_BANNERS版
 */
export function findMobileSpecialBarByArticleId(
  articleId: string,
): MobileSpecialBar | undefined {
  const matchingKey = MOBILE_SPECIAL_BARS.find((special) => {
    if (!special.articleIds || !special.articleIds.length) {
      return undefined;
    }
    return special.articleIds.some((id) => id === articleId);
  }) as MobileSpecialBar | undefined;

  if (!matchingKey) {
    return undefined;
  }
  return matchingKey;
}

export function shouldShowSpecialPage(
  articleId: string | undefined,
  isCorporationAccount: boolean,
  isPublisherAccount: boolean,
  isDoctorRecruiterAccount: boolean,
  isDemoAccount: boolean,
): boolean {
  if (isDemoAccount) {
    return false;
  }
  if (isCorporationAccount) {
    const publisherAllowedArticleIds = [
      'home-medical-care',
      'resident-internal-medicine',
      'designated-intractable-diseases-and-rare-diseases',
      'resident-handbook-campaign',
      'gsnet',
    ];
    if (
      isPublisherAccount &&
      publisherAllowedArticleIds.includes(articleId ?? '')
    ) {
      return true;
    }
    const doctorRecruiterAllowedArticleIds = [
      'home-medical-care',
      'resident-handbook-campaign',
      'resident-internal-medicine',
    ];
    if (
      isDoctorRecruiterAccount &&
      doctorRecruiterAllowedArticleIds.includes(articleId ?? '')
    ) {
      return true;
    }
    return false;
  }

  return true;
}
